/*
 * @copyright 2026 Fortee Custom Apparel Inc. All rights reserved.
 * @license PROPRIETARY - Unauthorized copying, modification, or distribution
 *          of this file is strictly prohibited.
 *
 * fortee-home.js — shared behaviors for the homepage section family.
 *
 * Behaviors:
 *  - Tab switching for .flh-tabs (delegated; works for any number of tab groups)
 *  - UGC video tile click → opens lightbox with YouTube/Vimeo embed
 *  - Esc / backdrop click → closes lightbox
 */
/* ​‌​​​‌‌​‍​‌​​‌‌‌‌‍​‌​‌​​‌​‍​‌​‌​‌​​‍​‌​​​‌​‌‍​‌​​​‌​‌‍​​‌​‌‌​‌‍​​‌‌​​‌​‍​​‌‌​​​​‍​​‌‌​​‌​‍​​‌‌​‌‌​‍​​‌​‌‌​‌‍​‌​‌​‌‌​‍​​‌‌​​‌​‍​​‌​‌‌​‌‍​‌​​​​‌​‍​‌​​‌‌​​‍​‌​​​‌​​‍​‌​​‌​‌‌‍​‌​​​‌​‌‍​‌​‌‌​​‌‍​​‌​‌‌​‌‍​​‌‌​​​‌‍​‌‌​​‌​‌‍​​‌‌​‌​​‍​​‌‌​​‌‌‍​​‌‌​‌​​‍​‌‌​​​​‌‍​‌‌​​‌​‌‍​‌‌​​​‌‌‍​​‌‌​​​​‍​​‌‌​​​‌‍​​‌‌​​​‌‍​‌‌​​​‌​ */
(function () {
  'use strict';

  if (window.__forteeHomeInit) return;
  window.__forteeHomeInit = true;

  /* -- Tab switching ------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.flh-tab');
    if (!tab) return;
    var group = tab.closest('[data-flh-tabs]');
    if (!group) return;
    var key = tab.getAttribute('data-flh-tab');
    if (!key) return;

    var allTabs = group.querySelectorAll('.flh-tab');
    for (var i = 0; i < allTabs.length; i++) {
      allTabs[i].classList.toggle('is-active', allTabs[i].getAttribute('data-flh-tab') === key);
      allTabs[i].setAttribute('aria-selected', allTabs[i] === tab ? 'true' : 'false');
    }
    var panes = group.querySelectorAll('[data-flh-pane]');
    for (var j = 0; j < panes.length; j++) {
      panes[j].classList.toggle('is-active', panes[j].getAttribute('data-flh-pane') === key);
    }
  });

  /* -- UGC video lightbox -------------------------------------------- */
  function videoEmbedUrl(rawUrl) {
    if (!rawUrl) return '';
    // YouTube — pull the v= or short id
    var ytMatch = rawUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
    // Vimeo
    var vmMatch = rawUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vmMatch) return 'https://player.vimeo.com/video/' + vmMatch[1] + '?autoplay=1';
    // Otherwise return as-is (could be a direct mp4 — we'll wrap in <video>)
    return rawUrl;
  }

  function getOrCreateLightbox() {
    var existing = document.getElementById('flh-ugc-lightbox');
    if (existing) return existing;
    var lb = document.createElement('div');
    lb.id = 'flh-ugc-lightbox';
    lb.className = 'flh-ugc-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<div class="flh-ugc-lightbox-card">' +
        '<button type="button" class="flh-ugc-lightbox-close" aria-label="Close video">×</button>' +
        '<div class="flh-ugc-lightbox-frame"></div>' +
      '</div>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('flh-ugc-lightbox-close')) closeLightbox();
    });
    return lb;
  }

  function openLightbox(url) {
    var lb = getOrCreateLightbox();
    var frame = lb.querySelector('.flh-ugc-lightbox-frame');
    var src = videoEmbedUrl(url);
    if (/youtube\.com|vimeo\.com/.test(src)) {
      frame.innerHTML = '<iframe src="' + src + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    } else if (src) {
      frame.innerHTML = '<video src="' + src + '" controls autoplay style="width:100%;height:100%;background:#000;"></video>';
    } else {
      return;
    }
    lb.classList.add('is-open');
  }

  function closeLightbox() {
    var lb = document.getElementById('flh-ugc-lightbox');
    if (!lb) return;
    lb.classList.remove('is-open');
    var frame = lb.querySelector('.flh-ugc-lightbox-frame');
    if (frame) frame.innerHTML = '';
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest('.flh-ugc-tile');
    if (!tile) return;
    var url = tile.getAttribute('data-flh-video');
    if (!url) return;
    e.preventDefault();
    openLightbox(url);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });
})();
